import Typography from "@mui/material/Typography";
import Box from "ui/atom/Box";


export default function Section({ title, indent, children }) {
	return (
		<Box.Column gap={1.25} pl={indent}>
			<Typography variant="h6">{title}</Typography>
			{children}
		</Box.Column>
	);
}